<template>
    <div class="render-post hide-scrollbar render-post-twitter" :style="{ fontSize: fontSize + 'px' }" ref="render-post">

        <div class="container-post-content">
            

            <div class="post-content">
                <div class="post-header">
                    
                    <div class="info">
                        <div class="img-pages">
                            <template v-for="(page, index) in pages.slice(0,pages.length == 4 ? 4 : 3)">
                                <Tooltip 
                                    :active="page.iconEdited" 
                                    :key="index" 
                                    :text="'Voir les modifications apportées'"
                                    position="right" 
                                    :classCustom="`page ${page.iconEdited ? 'iconEdited' : ''}`"
                                    @click="()=>{page.iconEdited ? $emit('clickPage', page.id) : openTwitterPage(page)}"
                                 >
                                    <img :src="page && page.avatar ? page.avatar : 'img/avatar.jpg'" alt="">
                                </Tooltip>
                            </template>

                            <div class="page count" v-if="pages.length > 4">
                                +{{ pages.length - 3 }}
                            </div>
                        </div>
                        <p>
                            <span class="name" v-if="pages.length == 1" @click="openTwitterPage(pages[0])">{{ pages[0].name }}</span>
                            <span class="name2" v-if="pages.length == 1">{{ '@'+pages[0].name }}</span>
                        </p>
                    </div>
                    <div class="more"><i class="fa-solid fa-ellipsis"></i></div>
                </div>
                <div class="post-text" v-if="text">
                    <p v-html="tweetSplittingContent.length ? tweetSplittingContent[0] : textTranslateMentionAndHastag"></p>
                </div>
               
                

              
                <div v-if="medias.length && medias.find(m => ['video', 'image'].includes(m.info.type2))" :class="'post-medias media'+medias.length">
                    <div class="media" v-for="(media) in medias.slice(0,4)" :class="{videoPreview: media.info.type.startsWith('video/')}" :key="media.id">
                        <div v-if="media.info.type.startsWith('video/')"  class="media-video" :class="{videoPlayed:videoPlayed}" @click="togglePlayPause()">
                            <img v-if="media.imagePreview && !videoPlayed" :src="media.imagePreview.url" alt="" class="imagePreview">
                            <video ref="videoPlayer" playsinline preload="metadata" class="video" loop :autoPlay="videoPlayed" :src="media.url" :type="media.info.type">
                         
                            </video>
                        </div>
                        <img v-else :src="media.url" alt="">
                    </div>
                
                </div>
                <div class="snippet" v-else-if="snippet.link">
                    <SnippetNetwork :link="snippet.link" :titleDefault="snippet.title" :imageUrlDefault="snippet.imageUrl" :descriptionDefault="snippet.description"></SnippetNetwork>
                </div>
                <div class="post-empty" v-else-if="!text"></div>
           
                <div class="post-footer">

                    <div class="top">
                        <p>{{ datePost ? formatDatePost : 'A l\'instant' }}</p>
                    </div>
                    <div class="bottom">
                        <div class="comments">
                           <svg viewBox="0 0 24 24" height="auto" width="auto" aria-hidden="true"><g><path d="M1.751 10c0-4.42 3.584-8 8.005-8h4.366c4.49 0 8.129 3.64 8.129 8.13 0 2.96-1.607 5.68-4.196 7.11l-8.054 4.46v-3.69h-.067c-4.49.1-8.183-3.51-8.183-8.01zm8.005-6c-3.317 0-6.005 2.69-6.005 6 0 3.37 2.77 6.08 6.138 6.01l.351-.01h1.761v2.3l5.087-2.81c1.951-1.08 3.163-3.13 3.163-5.36 0-3.39-2.744-6.13-6.129-6.13H9.756z"></path></g></svg>
                        </div>
                        <div class="share">
                            <svg viewBox="0 0 24 24" height="auto" width="auto" aria-hidden="true"><g><path d="M4.5 3.88l4.432 4.14-1.364 1.46L5.5 7.55V16c0 1.1.896 2 2 2H13v2H7.5c-2.209 0-4-1.79-4-4V7.55L1.432 9.48.068 8.02 4.5 3.88zM16.5 6H11V4h5.5c2.209 0 4 1.79 4 4v8.45l2.068-1.93 1.364 1.46-4.432 4.14-4.432-4.14 1.364-1.46 2.068 1.93V8c0-1.1-.896-2-2-2z"></path></g></svg>
                        </div>
                        <div class="like">
                            <svg viewBox="0 0 24 24" height="auto" width="auto" aria-hidden="true"><g><path d="M16.697 5.5c-1.222-.06-2.679.51-3.89 2.16l-.805 1.09-.806-1.09C9.984 6.01 8.526 5.44 7.304 5.5c-1.243.07-2.349.78-2.91 1.91-.552 1.12-.633 2.78.479 4.82 1.074 1.97 3.257 4.27 7.129 6.61 3.87-2.34 6.052-4.64 7.126-6.61 1.111-2.04 1.03-3.7.477-4.82-.561-1.13-1.666-1.84-2.908-1.91zm4.187 7.69c-1.351 2.48-4.001 5.12-8.379 7.67l-.503.3-.504-.3c-4.379-2.55-7.029-5.19-8.382-7.67-1.36-2.5-1.41-4.86-.514-6.67.887-1.79 2.647-2.91 4.601-3.01 1.651-.09 3.368.56 4.798 2.01 1.429-1.45 3.146-2.1 4.796-2.01 1.954.1 3.714 1.22 4.601 3.01.896 1.81.846 4.17-.514 6.67z"></path></g></svg>
                        </div>
                        <div class="signets">
                            <svg viewBox="0 0 24 24" height="auto" width="auto" aria-hidden="true"><g><path d="M4 4.5C4 3.12 5.119 2 6.5 2h11C18.881 2 20 3.12 20 4.5v18.44l-8-5.71-8 5.71V4.5zM6.5 4c-.276 0-.5.22-.5.5v14.56l6-4.29 6 4.29V4.5c0-.28-.224-.5-.5-.5h-11z"></path></g></svg>
                        </div>
                    </div>
                   
                </div>
                      
                <div class="comment-first" v-for="comment in tweetSplittingContent.slice(1).concat(commentsTranslateMentionAndHastag)">
                    <div class="image-auteur">
                        <img :src="!pages || !pages.length || pages.length > 1 || !pages[0] ?  'img/avatar.jpg' : pages[0].avatar" alt="">
                    </div>
                    <div class="content-comment">
                        <p>
                            <span class="name">{{ pages.length > 1 ? 'Commentaire' : pages[0].name}}</span>
                            <span class="name2">{{ pages.length > 1 ? 'Commentaire' : '@'+pages[0].name}}</span>
                            •
                            <span class="date">{{ datePost ? formatDatePost : 'A l\'instant' }}</span>
                        </p>
                        <p class="comment" v-html="comment"></p>
                    </div>
        
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import SnippetNetwork from './../SnippetNetwork.vue'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import renderPostMixin from '../../../mixins/renderPost';
    import { splitTags } from 'twitter-text';
    import { getContentSplitting } from '@/utils/networks/twitter/comment.js';

    export default {
        mixins: [renderPostMixin],

        components: {
            Carousel,
            Slide,
            SnippetNetwork,
            Tooltip
        },

        props: {
            pages: {
                type: Array,
                default: ()=>[] 
            },
            datePost: {
                default: '' 
            },
            text : {
                type: String,
                default: ''
            },
            comments : {
                type: Array,
                default: ()=>[]
            },
            medias: {
                type: Array,
                default: ()=>[] 
            },
            snippet: {
                type: Object,
                default: ()=>({
                    link : "",
                    title: "",
                    description: "",
                    domaine: "",
                    imageUrl: ""
                })
            },
            mentions: {
                type: Object,
                default: ()=>({})
            },

            verifiedMode: {
                type: Boolean,
                default: false
            },

            tweetSplitting: {
                type: Boolean,
                default: false
            }
           
        },

        data() {
            return {
                fontSize: 0,
                videoPlayed: false
            }
        },

        methods: {
            togglePlayPause(event) {
              
                if (!this.$refs.videoPlayer || !this.$refs.videoPlayer.length) {
                    this.videoPlayed=true
                    return
                }
                const video = this.$refs.videoPlayer[0]
    
                if (video.paused) {
                    video.play();
                    this.videoPlayed=true
                } else {
             
                    video.pause();
                    this.videoPlayed=false
                }
            },
            openTwitterPage(page) {
                const url = `https://twitter.com/${page.name}/`;
                window.open(url, '_blank');
            }
        },

        computed: {
            formatDatePost() {
                let dateMessage = this.datePost
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() + 1)){
                    return "Demain à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()+ ' • '+  dateMessage.toLocaleDateString(localStorage.language || undefined, { day: 'numeric', month: 'numeric', year: 'numeric' }) ;
                }
            },

            textTranslateMentionAndHastag() {
                //return this.text
                console.log('textTranslateMentionAndHastag', this.text)

                let text = this.text.replace(/<br\s*\/?>/gi, "\n")
        

                text = text.replace(/@(\d{13})/g, (match, id) => {
                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.twitter ? `@${mention.mention.twitter.username || mention.mention.twitter.id}` : mention.textDefault;
                    }
                    return match;
                })

                if (this.verifiedMode) {
                    text = text.substring(0, 25000);
                } else {
                    const twttr = require('twitter-text')
                    const parsed = twttr.default.parseTweet(text)
                    if (!parsed.valid) {
                        text = twttr.default.htmlEscape(text).substring(0, parsed.validRangeEnd+1)
                    }
                   
                    // const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });
                    // const graphemes = Array.from(segmenter.segment(text), seg => seg.segment);
                    
                }

                // text = text.replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/\n/g, '<br>');
                text = text.replace(/@[\u00C0-\u017Fa-zA-Z0-9._-]+/ig, '<span class="mention">$&</span>')
                text = text.replace(/#[\u00C0-\u017Fa-zA-Z0-9._-]+/ig, '<b class="hashtag">$&</b>')

                text = text.replace(
                    /https?:\/\/[^\s\n]+[^.\s\n]/g, 
                    (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
                )
               
                text = text.replace(/\n/g, '<br>');

                // text = text.replace(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/ig, "<a href='$1' target='_blank'>$1</a>")

                return text;
            },

            tweetSplittingContent() {
 
                if (this.verifiedMode || !this.tweetSplitting) return [];

                let text = this.text.replace(/@(\d{13})/g, (match, id) => {
                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.twitter ? `<span class="mention">@${mention.mention.twitter.username || mention.mention.twitter.id}</span>` : mention.textDefault;
                    }
                    return match;
                })
              
    
                return getContentSplitting(text)
               
            },

            commentsTranslateMentionAndHastag() {
                return this.comments.map(comment => (
                    comment.replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.twitter ? `<span class="mention">@${mention.mention.twitter.username || mention.mention.twitter.id}</span>` : mention.textDefault;
                    }
                    return match;
                    }).replace(/\n/g, '<br>')
                ))

            }
        },
    }



</script>
